import React, { Component } from 'react';
import { translate } from 'react-i18next';
import creditCards from '../../../images/credit-cards.png';
import spinner from '../../../images/loading-spinner.gif';

class AmexPaymentComponent extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const user = this.props.user;
    return(
      <div className="panel panel-default">
      {/* <div className="panel-heading">
                <button
                      className="btn btn-link"
                      data-target="#collapseTwo"
                      data-toggle="collapse"
                      type="button">
                      AMEX
                      <span className="caret" />
                    </button>
      </div> */}
      <div id="collapseTwo" className="panel-collapse collapse-in">
          <div className="panel-body">
             
          <div>
        <h4 className="page-header text-primary">
          <strong>{t('dashboard.room_payment.heading_userinfo')}</strong>
        </h4>
        <form method="post" onSubmit={this.props.handlePaymentSubmit}>
          <fieldset>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleEmailChange}
                    placeholder={t('dashboard.room_payment.holder_email')}
                    required={true}
                    type="email"
                    value={user ? user.email: ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleNameChange}
                    placeholder={t('dashboard.room_payment.holder_name')}
                    required={true}
                    type="text"
                    value={user? user.name : ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handleLastnameChange}
                    placeholder={t('dashboard.room_payment.holder_lastname')}
                    required={true}
                    type="text"
                    value={user ? user.lastname : ""} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    onChange={this.props.handlePhoneChange}
                    placeholder={t('dashboard.room_payment.holder_phone')}
                    required
                    type="tel"
                    value={user? user.phone : ""} />
                </div>
              </div>
            </div>
            {/* <div className="form-group">
                <img
                  className={this.props.isPaying ? "" : "hidden"}
                  width="45px"
                  height="45px"
                  alt={t('dashboard.room_payment.img_spinner')}
                  src={spinner} />
            </div>   */}
              <h4 className="page-header text-primary">
                <strong>{t('dashboard.room_payment.heading_payment')}</strong>
              </h4>
              <div className="row">
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCardName}
                      placeholder={t('dashboard.room_payment.holder_cname')}
                      required={true}
                      type="text"
                      value={this.props.cname} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      maxLength="16"
                      onChange={this.props.handleCardNumber}
                      placeholder={t('dashboard.room_payment.holder_cnumber')}
                      required={true}
                      type="text"
                      value={this.props.cnumber} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      max="12"
                      min="1"
                      onChange={this.props.handleCardMonth}
                      placeholder={t('dashboard.room_payment.holder_cmonth')}
                      required={true}
                      type="number"
                      value={this.props.cmonth} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      max="99"
                      min="19"
                      onChange={this.props.handleCardYear}
                      placeholder={t('dashboard.room_payment.holder_cyear')}
                      required={true}
                      type="number"
                      value={this.props.cyear} />
                  </div>
                </div>
                <div className="col-xs-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      maxLength="4"
                      onChange={this.props.handleCardCvc}
                      placeholder={t('dashboard.room_payment.holder_cvc')}
                      required={true}
                      type="number"
                      value={this.props.cvc} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <p>
                    <small className="text-muted">
                      {t('dashboard.room_payment.security')}
                    </small>
                  </p>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleStreetChange}
                      placeholder={t('dashboard.room_payment.holder_street')}
                      required={true}
                      type="text"
                      value={this.props.street} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleNeighborhoodChange}
                      placeholder={t('dashboard.room_payment.holder_neighborhood')}
                      required={true}
                      type="text"
                      value={this.props.neighborhood} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handlePoChange}
                      placeholder={t('dashboard.room_payment.holder_po')}
                      required={true}
                      type="number"
                      value={this.props.po} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCityChange}
                      placeholder={t('dashboard.room_payment.holder_city')}
                      required={true}
                      type="text"
                      value={this.props.city} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleStateChange}
                      placeholder={t('dashboard.room_payment.holder_state')}
                      required={true}
                      type="text"
                      value={this.props.state} />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <div className="form-group">
                    <input
                      className="form-control"
                      onChange={this.props.handleCountryChange}
                      placeholder={t('dashboard.room_payment.holder_country')}
                      required={true}
                      type="text"
                      value={this.props.country} />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <input
                          required={true}
                          type="checkbox"
                          value="" />
                        {t('dashboard.room_payment.terms')}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className={this.props.error ? "" : "hidden"}>
                    <div className="alert alert-warning">
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                      {this.props.error}
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="form-group">
                    <button
                      className="btn btn-primary"
                      disabled={this.props.isPaying}
                      type="submit">
                      {t('dashboard.room_payment.btn_pay')}
                    </button>
                    <img
                      className={this.props.isPaying ? "" : "hidden"}
                      width="45px"
                      height="45px"
                      alt={t('dashboard.room_payment.img_spinner')}
                      src={spinner} />
                  </div>
                </div>
                <div className="col-xs-6 text-right">
                  <img alt={t('dashboard.room_payment.img_credit')} width="150px" src={creditCards} />
                </div>
              </div>
           
          </fieldset>
        </form>
      </div>

          </div>
      </div>
  </div>
    );
  }
}

export default translate('common')(AmexPaymentComponent);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/AmexPaymentComponent.js